<div class="container-fluid">
  <!-- Superuser Context Switcher Banner -->
  <div *ngIf="isActingAsCustomer" class="alert alert-info d-flex justify-content-between align-items-center mb-3 shadow-sm border-0" style="background: linear-gradient(135deg, #004d47 0%, #007d79 100%); color: white; border-radius: 8px; padding: 12px 20px;">
    <div class="d-flex align-items-center">
      <i class="ri-user-shared-line me-2" style="font-size: 20px;"></i>
      <span>You are currently viewing customer <strong>{{ user?.user?.customerName || user?.user?.name }}</strong> portal.</span>
    </div>
    <button class="btn btn-light btn-sm font-weight-bold" (click)="returnToOemAdmin()" style="border-radius: 6px; color: #007d79; border: none; padding: 6px 14px;">
      <i class="ri-arrow-go-back-line me-1"></i> Switch Customer / Return
    </button>
  </div>

  <div class="row" style="margin-bottom: 0">
    <div class="col-12">
      <div
        class="page-title-box d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
        <h4 class="mb-0">Plant Dashboard</h4>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div *ngIf="ltu" class="text-nowrap">LUT: {{ ltu }}</div>
          &nbsp;
          <div (click)="refreshClick()" title="Refresh" class="d-flex align-items-center px-2 py-1 text-white" style="
              background-color: #007d79;
              cursor: pointer;
              border-radius: 5px;
              transition: background-color 0.3s ease;
              box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            ">
            <i class="ri-refresh-line me-1"></i> Refresh
          </div>
          <div class="example-button-row ml-2" *ngIf="this.role == 'SUPERADMIN'">
            <select class="form-control" [(ngModel)]="selectedCustomerId" (ngModelChange)="onChange($event)">
              <option *ngFor="let custId of customerList" [ngValue]="custId">
                {{ custId.custName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: -15px;">
    <div class="col-12">
      <div class="d-flex flex-column flex-md-row flex-wrap align-items-start align-items-md-center gap-2">
        <div class="status-card d-flex flex-wrap gap-2">
          <div class="status-bar total">
            <span>Total Devices</span>&nbsp;
            <span class="count">{{ responseData.length || 0 }}</span>
          </div>&nbsp;
          <div class="status-bar online" *ngIf="hasRunning">
            <span>Running</span>&nbsp;
            <span class="count">{{ counts.Running }}/{{ responseData.length || 0 }}</span>
          </div>&nbsp;
          <div class="status-bar idle" *ngIf="hasIdle">
            <span>Idle</span>&nbsp;
            <span class="count">{{ counts.Idle }}/{{ responseData.length || 0 }}</span>
          </div>&nbsp;
          <div class="status-bar offline" *ngIf="hasOff">
            <span>Off</span>&nbsp;
            <span class="count">{{ counts.Off }}/{{ responseData.length || 0 }}</span>
          </div>&nbsp;
          <div class="status-bar breakdown" *ngIf="hasBreakdown">
            <span>Breakdown</span>&nbsp;
            <span class="count">{{ counts.Breakdown }}/{{ responseData.length || 0 }}</span>
          </div>&nbsp;
          <div class="status-bar interlock" *ngIf="hasinterlock">
            <span>Interlock</span>&nbsp;
            <span class="count">{{ counts.Interlock }}/{{ responseData.length || 0 }}</span>
          </div>&nbsp;
        </div>

        <div class="marquee-container flex-grow-1">
          <div class="marquee">
            <span class="marqueeItem" *ngFor="let device of responseData">
              <span class="status-dot" [ngClass]="{
              'running': device.status === 'Running',
              'idle': device.status === 'Idle',
              'off': device.status === 'Off',
              'interlock': device.status === 'Interlock',
              'breakdown': device.status === 'Breakdown'
            }"></span>
              {{ device.deviceName }} - OEE:{{ device.oee }}%
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-12">
      <div class="row gx-1" style="margin-bottom: 0 !important;">
        <div class="col-12 col-md-6 col-xl-4 p-1">
          <div class="card p-2">
            <div class="cardbody">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0" style="font-weight: bold;">OEE </h6>
                <div class="d-flex align-items-center gap-2">
                  <select name="day" id="day" class="form-select form-select-sm"
                    style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                    [(ngModel)]="selectedOeeDay" (change)="onDayChange($event.target.value)">
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                  </select>
                  <i class="mdi mdi-dots-vertical text-muted" placement="top"
                    ngbPopover="Aailability * Performance * Quality" triggers="mouseenter:mouseleave" popoverTitle="OEE"
                    style="font-size: 14px; cursor: pointer;">
                  </i>
                </div>
              </div>
              <div class="d-flex flex-row align-items-center gap-2">
                <div class="d-flex justify-content-center" style="width: 100%;">
                  <div echarts [options]="oeeChartOption" class="chart-container" style="width: 100%; height: 150px;">
                  </div>
                </div>
                <div class="d-flex flex-column justify-content-center gap-2 w-100">
                  <div class="metric-card rounded text-black flex-fill px-2 py-1"
                    style="margin-bottom: 8px;background-color: #f8a9a9;">
                    <h6 class="mb-1">Availability</h6>
                    <h4 class="fw-bold mb-0">
                      {{ oeeDatas[selectedOeeDay] && oeeDatas[selectedOeeDay][0].avg_avail || 0 }}%
                    </h4>
                  </div>
                  <div class="d-flex justify-content-between metric-card rounded text-black flex-fill px-2 py-1"
                    style="margin-bottom: 8px;background-color: #9ef6ad;">
                    <div>
                      <h6 class="mb-1">Performance</h6>
                      <h4 class="fw-bold mb-0">
                        {{ oeeDatas[selectedOeeDay] && oeeDatas[selectedOeeDay][0].avg_perf || 0 }}%
                      </h4>

                    </div>
                    <div>
                      <i *ngIf="selectedOeeDay == 'today' && perfAlertData.length != 0"
                        (click)="openModel(perfTemp, 'performance')" class="mdi mdi-alert blinking-alert"
                        title="This data may be wrong, Why? To know Click" style="cursor: pointer;">

                      </i>
                    </div>
                  </div>
                  <div class="metric-card rounded text-black flex-fill px-2 py-1" style="background-color: #9cbdfc;">
                    <h6 class="mb-1">Quality</h6>
                    <h4 class="fw-bold mb-0">
                      {{ oeeDatas[selectedOeeDay] && oeeDatas[selectedOeeDay][0].avg_quality || 0 }}%
                    </h4>

                  </div>



                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-4 p-1 d-none d-xl-block">
          <div class="card p-2" style="margin-bottom: 5px;">
            <div class="cardbody">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0" style="font-weight: bold;">Energy Cost </h6>
                <div class="d-flex align-items-center gap-2">
                  <i *ngIf="energyAlertData.length != 0 && selectedEnergyDay == 'today'" title="This data may be wrong, Why? To know Click 👆"
                    class="mdi mdi-alert blinking-alert2" style="
                    cursor: pointer;" (click)="openModel(energyCost, 'energyCost')"></i>
                  <select name="day" id="day" class="form-select form-select-sm"
                    style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                    [(ngModel)]="selectedEnergyDay" (change)="onenergyDayChange($event.target.value)">
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                  </select>
                  <i class="mdi mdi-chart-line text-muted ml-1"
                    style="font-size: 12px; cursor: pointer; border: 1px solid #807b7b; padding: 0 3px; border-radius: 2px;"
                    (click)="openModel(energyHourlyCost, 'energyHourlyCost')">
                  </i>
                  <i class="mdi mdi-dots-vertical text-muted" placement="top"
                    ngbPopover="Energy Cost Per kWh * Engergy consumed" popoverTitle="Hourly Energy Cost"
                    triggers="mouseenter:mouseleave" style="font-size: 14px; cursor: pointer;">
                  </i>
                </div>
              </div>
              <div>
                <div echarts [options]="energycostOp" class="chart-container" style="width: 100%; height: 65px;">
                </div>
              </div>
            </div>
          </div>
          <div class="card p-2">
            <div class="cardbody">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0" style="font-weight: bold;">Opportunity Cost </h6>
                <div class="d-flex align-items-center gap-2">
                  <i *ngIf="revenueLossAlertData.length != 0 && selectedRevenueDay == 'today'" title="This data may be wrong, Why? To know Click 👆"
                    class="mdi mdi-alert blinking-alert2" style="
                    cursor: pointer;
                  " (click)="openModel(revenueTemp, 'revenueLoss')"></i>&nbsp;
                  <select name="day" id="day" class="form-select form-select-sm"
                    style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                    [(ngModel)]="selectedRevenueDay" (change)="onrevenueDayChange($event.target.value)">
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                  </select>
                  <i class="mdi mdi-chart-line text-muted ml-1"
                    style="font-size: 12px; cursor: pointer; border: 1px solid #807b7b; padding: 0 3px; border-radius: 2px;"
                    (click)="openModel(revenueHourlyLoss, 'revenueHourlyLoss')">
                  </i>
                  <i class="mdi mdi-dots-vertical text-muted" placement="top"
                    ngbPopover="Machine Cost Per Hour * Idle hours" triggers="mouseenter:mouseleave"
                    popoverTitle="Hourly Opportunity Trend" style="font-size: 14px; cursor: pointer;">
                  </i>
                </div>
              </div>
              <div>
                <div echarts [options]="revanuecostOp" class="chart-container" style="width: 100%; height: 65px;">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-4 col-md-6 p-1">
          <div class="card p-2" style="height: 228px;">
            <div class="cardbody d-flex flex-column h-100">
              <div class="d-flex align-items-center justify-content-between">
                <h6 class="mb-0" style="font-weight: bold;">Insights </h6>
                <div class="d-flex align-items-center gap-2">
                  <i class="mdi mdi-dots-vertical text-muted" placement="left" ngbPopover="Live Machine Data's"
                    triggers="mouseenter:mouseleave" popoverTitle="Overall Status"
                    style="font-size: 14px; cursor: pointer;">
                  </i>
                </div>
              </div>
              <ngb-carousel *ngIf="!showload3 && insightsData?.length" [interval]="3000" [pauseOnHover]="true"
                [wrap]="true" [showNavigationIndicators]="true" [showNavigationArrows]="true" class="custom-carousel">
                <ng-template ngbSlide *ngFor="let item of insightsData; let i = index">
                  <div class="rounded shadow text-white"
                    style="min-height: 150px; max-height: 150px; overflow-y: auto; background-color: #D6CFB4;">
                    <div class="p-4 ml-3">
                      <div class="fw-bold mb-2"
                        style="color: #030303 !important; font-size: 18px; font-size: clamp(14px, 3vw, 18px);">
                        {{ item.status }}
                      </div>
                      <div *ngFor="let machine of item.machinesData" class="mb-2">
                        <div class="fw-semibold"
                          style="color: #030303 !important; font-size: clamp(12px, 2.5vw, 16px);">
                          {{ machine.name }}
                        </div>
                        <div class="text-muted" style="color: #030303 !important; font-size: clamp(12px, 2.5vw, 16px);">
                          {{ machine.data }}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-carousel>
              <div *ngIf="showload3" class="d-flex flex-column align-items-center justify-content-center text-center">
                <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)"
                  type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner>
                <span style="margin-top: 115px" class="loading-animate">Loading</span>
              </div>
              <div *ngIf="!showload3 && insightsData?.length==0"
                class="d-flex flex-column align-items-center justify-content-center text-center"
                style="font-weight: bold;margin-top: 80px;">
                No Data
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-1 d-xl-none">
          <div class="card p-2" style="margin-bottom: 5px;">
            <div class="cardbody">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0" style="font-weight: bold;">Energy Cost </h6>
                <div class="d-flex align-items-center gap-2">
                  <i *ngIf="energyAlertData.length != 0 && selectedEnergyDay == 'today'" title="This data may be wrong, Why? To know Click 👆"
                    class="mdi mdi-alert blinking-alert2" style="
                    cursor: pointer;" (click)="openModel(energyCost, 'energyCost')"></i>
                  <select name="day" id="day" class="form-select form-select-sm"
                    style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                    [(ngModel)]="selectedEnergyDay" (change)="onenergyDayChange($event.target.value)">
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                  </select>
                  <i class="mdi mdi-chart-line text-muted ml-1"
                    style="font-size: 12px; cursor: pointer; border: 1px solid #807b7b; padding: 0 3px; border-radius: 2px;"
                    (click)="openModel(energyHourlyCost, 'energyHourlyCost')">
                  </i>
                  <i class="mdi mdi-dots-vertical text-muted" placement="top"
                    ngbPopover="Energy Cost Per hour * Engergy consumed" popoverTitle="Hourly Energy Cost"
                    triggers="mouseenter:mouseleave" style="font-size: 14px; cursor: pointer;">
                  </i>
                </div>
              </div>
              <div>
                <div echarts [options]="energycostOp" class="chart-container" style="width: 100%; height: 65px;">
                </div>
              </div>
            </div>
          </div>
          <div class="card p-2">
            <div class="cardbody">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0" style="font-weight: bold;">Opportunity Cost </h6>
                <div class="d-flex align-items-center gap-2">
                  <i *ngIf="revenueLossAlertData.length != 0" title="This data may be wrong, Why? To know Click 👆"
                    class="mdi mdi-alert blinking-alert2" style="
                    cursor: pointer;
                  " (click)="openModel(revenueTemp, 'revenueLoss')"></i>&nbsp;
                  <select name="day" id="day" class="form-select form-select-sm"
                    style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                    [(ngModel)]="selectedRevenueDay" (change)="onrevenueDayChange($event.target.value)">
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                  </select>
                  <i class="mdi mdi-chart-line text-muted ml-1"
                    style="font-size: 12px; cursor: pointer; border: 1px solid #807b7b; padding: 0 3px; border-radius: 2px;"
                    (click)="openModel(revenueHourlyLoss, 'revenueHourlyLoss')">
                  </i>
                  <i class="mdi mdi-dots-vertical text-muted" placement="top"
                    ngbPopover="Machine Cost Per Hour * Idle hours" triggers="mouseenter:mouseleave"
                    popoverTitle="Hourly Expense Trend" style="font-size: 14px; cursor: pointer;">
                  </i>
                </div>
              </div>
              <div>
                <div echarts [options]="revanuecostOp" class="chart-container" style="width: 100%; height: 65px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: -15px;" *ngIf="!showDepartmentTable">
        <div class="col-12 p-1">
          <div class="card h-100 shadow-sm p-3">
             <div class="mb-2">
              <button class="btn btn-sm btn-outline-secondary" (click)="backToDepartmentTable()">
                <i class="mdi mdi-arrow-left me-1"></i> Departments List
              </button>
          </div>
            <div class="d-flex flex-wrap justify-content-center gap-2 mb-3">
              <button *ngFor="let button of buttons" class="btn mx-1 flex-grow-1 responsive-btn d-button" [ngClass]="{
                  'selected-btn': selectedButton === button,
                  'unselected-btn': selectedButton !== button
                }" (click)="selectButton(button)">
                <i [ngClass]="getButtonIconClass(button)" class="mdi me-1"></i>
                {{ button }}
              </button>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6 class="mb-0" style="font-weight: bold;color: black;">{{selectedDepartment}} : {{selectedButton}}</h6>
                
              <div class="d-flex align-items-center gap-2">
                <i *ngIf="selectedProductionDay == 'today' && dapartperfAlertData.length != 0"
                        (click)="openModel(target, 'performance')" class="mdi mdi-alert blinking-alert"
                        title="This data may be wrong, Why? To know Click" style="cursor: pointer;">

                </i>&nbsp;
                <select name="day" id="day" class="form-select form-select-sm mr-1"
                  style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                  [(ngModel)]="selectedDepartment" (change)="ondepartmentChange($event.target.value)">
                  <option *ngFor="let department of departmentData" [value]="department.departmentName">{{
                    department.departmentName }}</option>
                </select>
                <select name="day" id="day" class="form-select form-select-sm"
                  style="font-size: 10px; padding: 1px 4px; height: auto; min-width: 70px;"
                  [(ngModel)]="selectedProductionDay" (change)="onproductionDayChange($event.target.value)">
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                </select>
              </div>
            </div>
            <div class="row gy-3" *ngIf="selectedButton == 'Production'">
              <div class="col-12">
                <div *ngIf="!showloadStatus && !showloadRejection" class="row">
                  <div class="col-12 col-lg-9">
                    <div echarts [options]="productionChartOption" (chartInit)="onProductionChartInit($event)"
                      class="chart-container" style="min-height: 300px">
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 mt-3 mt-lg-0">
                    <div echarts [options]="statusChartOption" class="chart-container" style="min-height: 300px"></div>
                  </div>
                </div>
                <div *ngIf="showloadStatus"
                  class="d-flex flex-column align-items-center justify-content-center text-center">
                  <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)"
                    type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner>
                </div>
              </div>
            </div>
            <div class="row gy-3" *ngIf="selectedButton == 'Downtime'">
              <div class="col-12">
                <div echarts [options]="losshourOptions" (chartInit)="onChartInit($event)" class="chart-container mt-2"
                  style="min-height: 250px"></div>
              </div>
            </div>
            <div class="row gy-3" *ngIf="selectedButton == 'Rejection'">
              <div class="col-12">
                <div echarts [options]="rejectionOption" (chartInit)="onrejectionChartInit($event)"
                  class="chart-container mt-2" style="min-height: 250px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: -15px;" *ngIf="showDepartmentTable">
        <div class="col-12 p-1">
          <div class="card p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <h6 class="mb-0" style="font-weight: bold;">Department-wise OEE</h6>&nbsp;
                <button class="btn btn-sm btn-outline-primary" (click)="gotodepartment()">
                <i class="mdi mdi-arrow-right me-1"></i> Department
              </button>
              </div>
              <h6 class="text-muted" style="font-size: 14px;font-weight: bold;">Click a department to view details</h6>
            </div>
            <div style="overflow-x: auto;">
              <table class="table table-bordered table-hover mb-0" style="font-size: 13px; cursor: pointer;">
                <thead class="table-light" style="font-size: 14px;">
                  <tr>
                    <th class="fw-bold">Department</th>
                    <th class="fw-bold">OEE %</th>
                    <th class="fw-bold">Availability %</th>
                    <th class="fw-bold">Performance %</th>
                    <th class="fw-bold">Quality %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let dept of departmentOeeData"
                    (click)="onDepartmentTableRowClick(dept)"
                    title="click to view production data"
                    style="cursor: pointer;">
                    <td><strong>{{ dept.departmentName }}</strong></td>
                    <td>
                      <span class="badge"
                        [style.background-color]="dept.avg_oee >= 80 ? '#6BCB77' : dept.avg_oee >= 50 ? '#FFD93D' : '#FF6B6B'"
                        style="color: #000; font-size: 12px; padding: 4px 8px; border-radius: 4px;">
                        {{ dept.avg_oee }}%
                      </span>
                    </td>
                    <td>{{ dept.avg_avail }}%</td>
                    <td>{{ dept.avg_perf }}%</td>
                    <td>{{ dept.avg_quality }}%</td>
                  </tr>
                  <tr *ngIf="departmentOeeData.length === 0">
                    <td colspan="5" class="text-center text-muted">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #perfTemp let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">
      Set the “X” marked parameters to get the right value
    </h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="container-fluid">
      <div *ngIf="perfAlertData.length > 0">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of perfAlertData">
            <div class="stepper-card">
              <div class="machine-name">{{ item.machineName }}</div>

              <div class="step" *ngFor="let step of getSteps(item)">
                <div class="step-icon">
                  <i *ngIf="step.status" class="ri-hasBreakdown box-circle-fill" style="color: green"></i>
                  <i *ngIf="!step.status" class="ri-close-circle-fill" style="color: red"></i>
                </div>
                <div class="step-line"></div>
                <div class="step-label">{{ step.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="perfAlertData.length === 0" class="text-center mt-4">
        No data available.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #target let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">
      Set the “X” marked parameters to get the right value
    </h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="container-fluid">
      <div *ngIf="dapartperfAlertData.length > 0">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of dapartperfAlertData">
            <div class="stepper-card">
              <div class="machine-name">{{ item.machineName }}</div>

              <div class="step" *ngFor="let step of getSteps2(item)">
                <div class="step-icon">
                  <i *ngIf="step.status" class="ri-hasBreakdown box-circle-fill" style="color: green"></i>
                  <i *ngIf="!step.status" class="ri-close-circle-fill" style="color: red"></i>
                </div>
                <div class="step-line"></div>
                <div class="step-label">{{ step.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="dapartperfAlertData.length === 0" class="text-center mt-4">
        No data available.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #revenueTemp let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">
      Set the “X” marked parameters to get the right value
    </h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="container-fluid">
      <div *ngIf="revenueLossAlertData.length > 0">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of revenueLossAlertData">
            <div class="stepper-card">
              <div class="machine-name">{{ item.machineName }}</div>

              <div class="step" *ngFor="let step of getrevnueSteps(item)">
                <div class="step-icon">
                  <i *ngIf="step.status" class="ri-hasBreakdown box-circle-fill" style="color: green"></i>
                  <i *ngIf="!step.status" class="ri-close-circle-fill" style="color: red"></i>
                </div>
                <div class="step-line"></div>
                <div class="step-label">{{ step.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="revenueLossAlertData.length === 0" class="text-center mt-4">
        No data available.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #energyCost let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">
      Set the “X” marked parameters to get the right value
    </h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="container-fluid">
      <div *ngIf="energyAlertData.length > 0">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of energyAlertData">
            <div class="stepper-card">
              <div class="step" *ngFor="let step of getenergyCost(item)">
                <div class="step-icon">
                  <i *ngIf="step.status" class="ri-hasBreakdown box-circle-fill" style="color: green"></i>
                  <i *ngIf="!step.status" class="ri-close-circle-fill" style="color: red"></i>
                </div>
                <div class="step-line"></div>
                <div class="step-label">{{ step.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="energyAlertData.length === 0" class="text-center mt-4">
        No data available.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #downtime let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">Machine wise Downtime</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="container-fluid">
      <div echarts [options]="machDowntime" class="chart-container" style="min-height: 250px"></div>
    </div>
  </div>
</ng-template>
<ng-template #hourlyProduction let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">Machine wise Production</h6>
    <div class="d-flex">
      <div class="justify-content-start">
        <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
      </div>
      <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body card-body">
    <div class="container-fluid">
      <div *ngIf="machines.length > 0">
        <div style="overflow-x: auto; display: block; width: 100%; max-width: 100vw;">
          <table class="table table-bordered table-striped table-centered datatable dt-responsive nowrap mb-0"
            style="font-size: 14px;">
            <thead class="table-light">
              <tr>
                <th>Machine</th>
                <th>Target</th>
                <th>Produced</th>
                <th>Pending</th>
                <th>CurrentRate</th>
                <th>RequiredRate</th>
                <th>Expected</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                let machine of machines
                  | slice : pageSize
                  | slice : 0 : itemsPerPage
                  | filter: searchTerm">
                <td>{{ machine.name }}</td>
                <td>{{ machine.target }}</td>
                <td>
                  {{ machine.partProduced }}
                </td>
                <td>
                  {{ machine.remaining }}
                </td>
                <td style="color: #3A7D44;">
                  {{ machine.currentRate }}/hr
                </td>
                <td style="color: #E94F37;">
                  {{ machine.requiredRate }}/hr
                </td>

                <td>
                  At current rate, {{ machine.exceptedCount }} units expected in
                  {{machine.remainingHours}} hr.
                </td>
              </tr>
            </tbody>
          </table>
          <div class="col-md-6" *ngIf="machines?.length > 5">
            <ngb-pagination class="pagination-rounded" [collectionSize]="machines?.length" #numPages
              [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true" [ellipses]="false"
              [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>
<ng-template #hourlyRejection let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">Machine wise Rejection</h6>
    <div class="d-flex">
      <div class="justify-content-start">
        <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
      </div>
      <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="modal-body card-body">
    <div class="container-fluid">
      <div *ngIf="rejectionMachines.length > 0">

        <div style="overflow-x: auto; display: block; width: 100%; max-width: 100vw;">
          <table class="table table-bordered table-striped table-centered datatable dt-responsive nowrap mb-0"
            style="font-size: 14px;">
            <thead class="table-light">
              <tr>
                <th>Machine</th>
                <th>Produced</th>
                <th>Rejected</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let machine of rejectionMachines
                  | slice : pageSize
                  | slice : 0 : itemsPerPage
                  | filter: searchTerm">
                <td>{{ machine.name }}</td>
                <td>{{ machine.partProduced }}</td>
                <td>{{ machine.rejected }}</td>
              </tr>
            </tbody>
          </table>
          <div class="col-md-6" *ngIf="rejectionMachines?.length > 5">
            <ngb-pagination class="pagination-rounded" [collectionSize]="rejectionMachines?.length" #numPages
              [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true" [ellipses]="false"
              [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
            </ngb-pagination>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #energyHourlyCost let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">Hourly Energy Trend</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body card-body">
    <div class="container-fluid">
      <div echarts [options]="energyChartOption" class="chart-container" style="min-height: 250px"></div>
    </div>
  </div>
</ng-template>
<ng-template #revenueHourlyLoss let-modal="close">
  <div class="modal-header">
    <h6 class="modal-title">Hourly Opportunity Trend</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body card-body">
    <div class="container-fluid">
      <div echarts [options]="revenueChartOption" class="chart-container" style="min-height: 250px"></div>
    </div>
  </div>
</ng-template>
